export enum NonFooterUrls {
  REGISTER = '/register',
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgotPassword',
  SET_NEW_PASSWORD = '/setNewPassword',
  NOT_FOUND = '/notFound',
}
